export default [
  "Career development",
  "Skill building",
  "Gain business contacts",
  "Build my professional network",
  "Meet like-minded women",
  "Attend speaker events",
  "Socialise",
  "Co-work & take meetings",
  "Other",
] as const;
